import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { UserContext } from '../UserContext';
import './GroupLeaderboard.css';

const API_BASE_URL = 'https://wholeness-forward.onrender.com/api'; // ✅ Ensure correct API base URL

const GroupLeaderboard = () => {
    const { user } = useContext(UserContext); // ✅ Ensure user context is used
    const [groups, setGroups] = useState([]); // ✅ State for storing groups
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState(''); // ✅ Search state
    const [timeframe, setTimeframe] = useState('allTime'); // ✅ Timeframe state
    

    // ✅ Fetch Group Leaderboard Data with Timeframe Filter
    useEffect(() => {
        const fetchGroups = async () => {
            setLoading(true);
            setError(null);

            try {
               
                const response = await axios.get(`${API_BASE_URL}/group/all-groups?timeframe=${timeframe}`, {
                });

                console.log("✅ Groups Data Received:", response.data);

                // ✅ Sort groups by total weight lost (descending order) and assign ranks
                const sortedGroups = response.data
                    .sort((a, b) => parseFloat(b.totalWeightLost) - parseFloat(a.totalWeightLost)) // Ensure numeric sorting
                    .map((group, index) => ({ ...group, rank: index + 1 })); // ✅ Assign rank after sorting

                setGroups(sortedGroups);
            } catch (err) {
                console.error("❌ Error fetching groups:", err.response?.data || err.message);
                setError(err.response?.data?.error || "Failed to fetch groups.");
            } finally {
                setLoading(false);
            }
        };

        fetchGroups();
    }, [user, timeframe ]); 

    // ✅ Search Filtering (Preserve Rank)
    const searchFilteredGroups = groups.filter(group =>
        group.name.toLowerCase().includes(search.toLowerCase())
    );

    if (loading) return <div className="loading">🔄 Loading leaderboard...</div>;
    if (error) return <div className="error-message">❌ {error}</div>;

    return (
        <div className="group-page-container">
                        <img src="/images/weighlogo.png" alt="WeighForward Logo" className="leader-logo" />
                        <h1 className="group-title">WeighForward Leaderboard</h1>

            <div className="leaderboard-section">
                <h3>Group Rankings</h3>
                <div className="micro-void"></div>

                
            {/* Timeframe Dropdown */}
            <div className="timeframe-selector">
                <label>Show data for:</label>
                <select value={timeframe} onChange={(e) => setTimeframe(e.target.value)}>
                    <option value="allTime">All Time</option>
                    <option value="week">This Week</option>
                    <option value="month">This Month</option>
                    <option value="year">This Year</option>
                </select>
            </div>

                        {/* ✅ Search Bar */}
                        <input
                type="text"
                placeholder="Search by group name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="search-bar"
            />
            

                <table className="mini-leaderboard-table">
                    <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Group Name</th>
                            <th>Total Weight Lost (lbs)</th>
                            <th>Members</th>
                        </tr>
                    </thead>
                    <tbody>
                        {searchFilteredGroups.length === 0 ? (
                            <tr><td colSpan="4">❌ No data available</td></tr>
                        ) : (
                            searchFilteredGroups.map(group => (
                                <tr key={group._id}>
                                    <td># {group.rank}</td> {/* ✅ Use Sorted Rank */}
                                    <td>{group.name}</td>
                                    <td className={
                                        parseFloat(group.totalWeightLost) > 0 ? "loss" :
                                        parseFloat(group.totalWeightLost) < 0 ? "gain" :
                                        "neutral"
                                    }>
                                        {group.weightLost !== "N/A" ? `${group.totalWeightLost} lbs` : "N/A"}
                                    </td>
                                    <td>{group.memberCount || 0}/{group.maxMembers || 0}</td> {/* Safe check for null/undefined */}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <div className="mini-void"></div>

            {/* 🔙 Back to Main Leaderboard */}
            <Link to="/leaderboard" className="leaderboard-link">← Back to Main Leaderboard</Link>
        </div>
    );
};

export default GroupLeaderboard;
